// Dependency
import React from "react";

// Internationalization
import { useTranslation } from 'react-i18next';

// Styles
import * as marqueeStyles from '../components/marquee.module.scss'

// Template
const Marquee = (props) => {

    // Translation Function
    const { t } = useTranslation();

    return (
        <div className={`${marqueeStyles.cdMarqueeWrapper} ${props.cname}`}>
            <div className={marqueeStyles.marquee}>
                <div className={marqueeStyles.marquee__content}>
                    <ul className={marqueeStyles.listInline}>
                        <li>{t('marquee.free')} <span>{t('marquee.shipping')}</span></li>
                        <li>{t('marquee.always')} <span>{t('marquee.freePlural')}</span> {t('marquee.returns')}</li>
                        <li><span>100 {t('marquee.days')}</span> {t('marquee.satisfaction')}</li>
                    </ul>
                    <ul className={marqueeStyles.listInline}>
                        <li>{t('marquee.free')} <span>{t('marquee.shipping')}</span></li>
                        <li>{t('marquee.always')} <span>{t('marquee.freePlural')}</span> {t('marquee.returns')}</li>
                        <li><span>100 {t('marquee.days')}</span> {t('marquee.satisfaction')}</li>
                    </ul>
                    <ul className={marqueeStyles.listInline}>
                        <li>{t('marquee.free')} <span>{t('marquee.shipping')}</span></li>
                        <li>{t('marquee.always')} <span>{t('marquee.freePlural')}</span> {t('marquee.returns')}</li>
                        <li><span>100 {t('marquee.days')}</span> {t('marquee.satisfaction')}</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Marquee
